import { memo } from 'react'
import { CompareItemsTableSpacerCell as TCompareItemsTableSpacerCell } from '../../types'

import style from './SpacerCell.module.scss'

export default memo(
  CompareItemsTableSpacerCell,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width &&
    prevProps.className === nextProps.className &&
    prevProps.cell.height === nextProps.cell.height
)
export function CompareItemsTableSpacerCell({
  className,
  width,
  cell
}: {
  className: string
  width: number
  cell: TCompareItemsTableSpacerCell
}) {
  return (
    <div
      className={`${className || ''} ${style.CompareItemsTableSpacerCell}`}
      style={{ flex: `0 0 ${width}px`, width: `${width}px`, height: cell.height, zIndex: cell.zIndex }}
    />
  )
}
